import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CarouselModule, MediaModule, OutletModule, StarRatingModule } from '@spartacus/storefront';

import { KnBrProductImagesComponent } from './kn-br-product-images/kn-br-product-images.component';
import { KnBrProductIntroComponent } from './kn-br-product-intro/kn-br-product-intro.component';
import { KnBrProductSummaryComponent } from './kn-br-product-summary/kn-br-product-summary.component';
import { KnBrProductInfoDetailComponent } from './kn-br-product-info-detail/kn-br-product-info-detail.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { KnBrProductLiteratureComponent } from './kn-br-product-literature/kn-br-product-literature.component';
import { KnBrTechnicalInstallationComponent } from './kn-br-technical-installation/kn-br-technical-installation.component';
import { FormsModule } from '@angular/forms';
import { KnBrKeyFeatureComponentsComponent } from './kn-br-key-feature-components/kn-br-key-feature-components.component';
import { KnBrAddToCartModule } from '../kn-br-add-to-cart/kn-br-add-to-cart.module';
import { CwtSpinnerModule } from 'src/app/common/cwt-spinner/cwt-spinner.module';
import { KnBrProductFeatureComponent } from './kn-br-product-feature/kn-br-product-feature.component';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        KnBrAddToCartModule,
        StarRatingModule,
        RouterModule,
        NgbModule,
        FormsModule,
        MediaModule,
        OutletModule,
        CarouselModule,
        CwtSpinnerModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrProductIntroComponent: {
                    component: KnBrProductIntroComponent,
                },
                KnBrProductImagesComponent: {
                    component: KnBrProductImagesComponent,
                },
                KnBrProductSummaryComponent: {
                    component: KnBrProductSummaryComponent,
                },
                CwtProductSummaryComponent: {
                    component: KnBrProductSummaryComponent,
                },
                KnBrProductDetailTabsComponent: {
                    component: KnBrProductInfoDetailComponent,
                },
                CwtProductDetailsTabComponent: {
                    component: KnBrProductInfoDetailComponent,
                },
                CwtProductImagesComponent: {
                    component: KnBrProductImagesComponent
                },
                CwtProductLiteratureTabComponent: {
                    component: KnBrProductLiteratureComponent
                },
                CwtProductTechInstallationTabComponent: {
                    component: KnBrTechnicalInstallationComponent
                },
                CwtKnowledgeComponent: {
                    component: KnBrKeyFeatureComponentsComponent
                },
                CwtProductFeatureComponent: {
                    component: KnBrProductFeatureComponent
                },
            },
        } as CmsConfig),
        KnBrProductIntroComponent, KnBrProductImagesComponent, KnBrProductSummaryComponent, KnBrProductInfoDetailComponent, KnBrProductLiteratureComponent, KnBrTechnicalInstallationComponent, KnBrKeyFeatureComponentsComponent, KnBrProductFeatureComponent,
    ],
    exports: [KnBrProductIntroComponent, KnBrProductImagesComponent, KnBrProductSummaryComponent, KnBrProductInfoDetailComponent, KnBrProductLiteratureComponent, KnBrProductFeatureComponent]
})
export class KnBrProductDetailModule {}
